export default __webpack_public_path__ + "locales/uk-UA/MainBar.json?hash=4f43518832b45dfe755b2478c4453389";